import IconAlert from "assets/img/alert-icon.svg";

interface IBlockquoteProps {
  children: React.ReactNode;
  isCenterFlex?: boolean;
}
const Blockquote = ({ children, isCenterFlex }: IBlockquoteProps) => {
  return (
    <div
      role="alert"
      aria-live="polite"
      className={`mt-10 bg-cyan-10 text-color-02 rounded-default py-4 px-8 flex ${
        isCenterFlex ? "items-center" : "items-start"
      }`}
    >
      <img src={IconAlert} alt="Icono de alerta" aria-hidden="true" width="auto" height="auto"/>
      <div className="ml-10">{children}</div>
    </div>
  );
};

export default Blockquote;
